import { BodyText, StrongValue, SummaryCard } from '@if/mui'
import { Link, Stack } from '@mui/material'
import { FinancingCompanyConfigs } from '@src/types/Constants'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  fundingSummary: FundingSummaryDto
}

const NeedHelpCard = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()
  // Per-company support line, same source the app bar uses (FinancingCompanyConfigs[company].phone).
  const phone = FinancingCompanyConfigs[fundingSummary.financingCompanyId]?.phone

  return (
    <SummaryCard title={t('fundingSummary.needHelp')} icon={Phone}>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <BodyText>{t('fundingSummary.changesRequiredNote')}</BodyText>
          {phone && (
            <Link href={`tel:${phone.replace(/[^\d+]/g, '')}`}>
              <StrongValue>{phone}</StrongValue>
            </Link>
          )}
        </Stack>
        <BodyText>{t('fundingSummary.contactUsIfBankDetailsChanged')}</BodyText>
      </Stack>
    </SummaryCard>
  )
}

export default NeedHelpCard
